import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from '../components';
import { AuthGuard } from '../guards';
import * as Pages from '../pages';

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Pages.Login />
      },
      {
        path: 'home',
        element: <Pages.Home />
      },
      {
        path: 'hospital',
        children: [
          {
            index: true,
            element: <Pages.Hospital />
          },
          {
            path: 'appointment-booking',
            children: [
              {
                index: true,
                element: <Pages.HMS />
              },
              {
                path: 'appointment-booking',
                element: <Pages.AppointmentBooking />
              },
              {
                path: 'appointment-status',
                element: <Pages.AppointmentStatus />
              }
            ]
          },
          {
            path: 'patient-admission',
            children: [
              {
                index: true,
                element: <Pages.PatientRegisteration />
              },
              {
                path: 'collection-summary',
                element: <Pages.CollectionSummary />
              },
              {
                path: ':patientId/documents',
                element: <Pages.PatientDocumentsPage />
              }
            ]
          },
          {
            path: 'outpatient-management',
            children: [
              {
                index: true,
                element: <Pages.HMS />
              },
              {
                path: 'service-master',
                element: <Pages.ServiceMaster />
              },
              {
                path: 'doctor-unit-master',
                element: <Pages.DoctorUnitMaster />
              },
              {
                path: 'doctor-master',
                element: <Pages.DoctorMaster />
              },
              {
                path: 'opd-type',
                element: <Pages.OPDType />
              },
              {
                path: 'admission-type',
                element: <Pages.AdmissionType />
              },
              {
                path: 'patient-type',
                element: <Pages.PATIENTType />
              },
              {
                path: 'relation-master',
                element: <Pages.RelationMaster />
              },
              {
                path: 'department-master',
                element: <Pages.DepartmentMaster />
              },
              {
                path: 'location-master',
                element: <Pages.LocationMaster />
              },
              {
                path: 'state-master',
                element: <Pages.StateMaster />
              },
              {
                path: 'city-master',
                element: <Pages.CityMaster />
              },
              {
                path: 'speciality-master',
                element: <Pages.SpecialityMaster />
              },
              {
                path: 'feegroup-master',
                element: <Pages.FeeGroupMaster />
              },
              {
                path: 'vertical-master',
                element: <Pages.VerticalMaster />
              },
              {
                path: 'group-master',
                element: <Pages.GroupMaster />
              },
              {
                path: 'subgroup-master',
                element: <Pages.SubGroupMaster />
              },
              {
                path: 'reason-master',
                element: <Pages.ReasonMaster />
              },
              {
                path: 'flutype-master',
                element: <Pages.FluTypeMaster />
              },
              {
                path: 'medical-emergency-master',
                element: <Pages.MedicalEmergencyMaster />
              },
              {
                path: 'rank-master',
                element: <Pages.RankMaster />
              },
              {
                path: 'opd-billing',
                element: <Pages.OPDBilling />
              },
              {
                path: 'patient-registeration',
                element: <Pages.PatientRegisteration />
              },
              {
                path: 'patient-registeration/:patientId/documents',
                element: <Pages.PatientDocumentsPage />
              },
              {
                path: 'sponsor-master',
                element: <Pages.SponsorMaster />
              },
              {
                path: 'referral-master',
                element: <Pages.ReferralMaster />
              },
              {
                path: 'service-master',
                element: <Pages.ServiceMaster />
              },
              {
                path: 'control-unit-master',
                element: <Pages.ControlUnitMaster />
              },
              {
                path: 'discount-master',
                element: <Pages.DiscountMaster />
              },
              {
                path: 'scheme-allotment',
                element: <Pages.SchemeAllotment />
              },
              {
                path: 'indoor-registeration',
                element: <Pages.IndoorRegisteration />
              },
              {
                path: 'room-master',
                element: <Pages.RoomMaster />
              },
              {
                path: 'ward-category-master',
                element: <Pages.WardCategoryMaster />
              },
              {
                path: 'ward-master',
                element: <Pages.WardMaster />
              },
              {
                path: 'floor-master',
                element: <Pages.FloorMaster />
              },
              {
                path: 'nursing-station-master',
                element: <Pages.NursingStationMaster />
              },
              {
                path: 'department-unit-master',
                element: <Pages.DepartmentUnitMaster />
              },
              {
                path: 'indoor-billing-management',
                element: <Pages.IndoorBillingManagement />
              },
              {
                path: 'payment-refund-voucher',
                element: <Pages.PaymentRefundVoucher />
              },
              
              {
                path: 'indoor-service',
                element: <Pages.IndoorService />
              },
              {
                path: 'receipt-voucher',
                element: <Pages.ReceiptVoucher />
              },
              {
                path: 'indoor-status',
                element: <Pages.IndoorStatus />
              },
              {
                path: 'patient-discharge',
                element: <Pages.PatientDischarge />
              },
              {
                path: 'consultant-transfer',
                element: <Pages.ConsultantTransfer />
              },
              {
                path: 'change-ipd-sponsor',
                element: <Pages.ChangeIpdSponsor />
              },
              {
                path: 'discharge-summary',
                element: <Pages.DischargeSummary />
              },
              {
                path: 'main-group-master',
                element: <Pages.MainGroupMaster />
              },
              {
                path: 'main-group-master',
                element: <Pages.MainGroupMaster />
              },
              {
                path: 'emr-sub-group-master',
                element: <Pages.EmrSubGroupMaster />
              },
              {
                path: 'emr-test-item',
                element: <Pages.EmrTestItemMaster />
              },
              {
                path: 'doctor-fees-setup',
                element: <Pages.DoctorFeeSetup />
              },
              {
                path: 'collection-summary',
                element: <Pages.CollectionSummary />
              },
              {
                path: 'appointment-register-report',
                element: <Pages.AppointmentRegisterReport />
              },
              {
                path: 'registration-register',
                element: <Pages.RegistrationRegister />
              },
              {
                path: 'consultant-wise-opd',
                element: <Pages.ConsultantWiseOpdReport />
              },
              {
                path: 'department-wise-opd',
                element: <Pages.DepartmentWiseOpdReport />
              },
              {
                path: 'sponsor-wise-opd',
                element: <Pages.SponsorWiseOpdReport />
              },
              {
                path: 'opd-patient-ledger',
                element: <Pages.OpdPatientLedger />
              },
              {
                path: 'due-payment-register',
                element: <Pages.DuePaymentRegisterReport />
              },
              {
                path: 'opd-patient-vitals-reports',
                element: <Pages.OpdPatientVitalsReport />
              },
              {
                path: 'doctor-wise-opd-procedure-reports',
                element: <Pages.DoctorWiseOpdProcedureReport />
              },
              {
                path: 'active-patient-reports',
                element: <Pages.IpdActivePatientReport />
              },

              {
                path: 'reception-enquiry',
                element: <Pages.ReceptionEnquiry />
              },
              {
                path: 'print-layout',
                element: <Pages.PrintLayout />
              },
              {
                path: 'service-master-report',
                element: <Pages.ServiceMasterReport />
              },
              {
                path: 'service-package-report',
                element: <Pages.ServicePackageReport />
              },
              {
                path: 'doctor-master-report',
                element: <Pages.DoctorMasterReport />
              },
              {
                path: 'opd-vitals',
                element: <Pages.OpdRequisition />
              },
              {
                path: 'opd-vital-report',
                element: <Pages.OpdVitalsReport />
              },
              {
                path: 'doctor-ledger-report',
                element: <Pages.DoctorLedgerReport />
              },
              {
                path: 'discharge-summary-template-master',
                element: <Pages.DischargeSummaryTemplateMaster />
              },
              {
                path: 'user-wise-doctor-mapping',
                element: <Pages.UserWiseDoctorMapping />
              },
              {
                path: 'authority-master',
                element: <Pages.AuthorityMaster />
              },
              {
                path: 'queue-details',
                element: <Pages.QueueManagementDetails />
              },
              {
                path: 'partial-cancellation',
                element: <Pages.PartialCancellation />
              }
            ]
          },

          {
            path: 'health-checkup',
            children: [
              {
                index: true,
                element: <Pages.HMS />
              },
              {
                path: 'opd-billing',
                element: <Pages.OPDBilling />
              }
            ]
          },

          {
            path: 'laboratory',
            children: [
              {
                index: true,
                element: <Pages.LIS />
              },
              {
                path: 'test-main-group-master',
                element: <Pages.TestMainGroupMaster />
              },
              {
                path: 'test-sub-group-master',
                element: <Pages.TestSubGroupMaster />
              },
              {
                path: 'category-master',
                element: <Pages.CategoryMaster />
              },
              {
                path: 'lis-price-list-master',
                element: <Pages.LisPriceListMaster />
              },
              {
                path: 'specimen-master',
                element: <Pages.SpecimenMaster />
              },
              {
                path: 'tube-type-master',
                element: <Pages.TubeTypeMaster />
              },
              {
                path: 'unit-master',
                element: <Pages.LisUnitMaster />
              },
              {
                path: 'lis-discount-master',
                element: <Pages.DiscountsMaster />
              },
              {
                path: 'out-source-lab-master',
                element: <Pages.OutSourceLabMaster />
              },
              {
                path: 'lab-diagnosis-master',
                element: <Pages.LabDiagnosisMaster />
              },
              {
                path: 'lis-remark-master',
                element: <Pages.RemarksMaster />
              },
              {
                path: 'lis-reason-master',
                element: <Pages.ReasonsMaster />
              },
              {
                path: 'antimicrobials-master',
                element: <Pages.AntimicrobialsMaster />
              },
              {
                path: 'sensitivity-master',
                element: <Pages.SensitivityMaster />
              },
              {
                path: 'machine-master',
                element: <Pages.MachineMaster />
              },
              {
                path: 'lis-discount-authority-master',
                element: <Pages.DiscountAuhtorityMaster />
              },
              {
                path: 'lis-sponsor-master',
                element: <Pages.LisSponsorMaster />
              },
              {
                path: 'lis-templates-master',
                element: <Pages.LisTemplatesMaster />
              },
              {
                path: 'lis-referral-master',
                element: <Pages.LisReferralMaster />
              },
              {
                path: 'lis-rate-list-master',
                element: <Pages.LisRateListMaster />
              },
              {
                path: 'price-list-bed-category-wise',
                element: <Pages.PriceListBedCategoryWise />
              },
              {
                path: 'lis-test-price-list',
                element: <Pages.LisPriceListMaster />
              },
              {
                path: 'test-price-management',
                element: <Pages.TestPriceManagement />
              },
              {
                path: 'collection-center',
                element: <Pages.CollectionCenterMaster />
              },
              {
                path: 'lab-authority-doctor-master',
                element: <Pages.LabAuthorityDoctorMaster />
              },
              {
                path: 'machine-testitem-mapping',
                element: <Pages.MachineTestItemMapping />
              },
              {
                path: 'referral-share-setup',
                element: <Pages.ReferralShareSetup />
              },
              {
                path: 'doctor-share-setup',
                element: <Pages.DoctorShareSetup />
              },
              {
                path: 'test-master',
                element: <Pages.LisTestMaster />
              },
              {
                path: 'test-panel-master',
                element: <Pages.LisTestPanelMaster />
              },
              {
                path: 'investigation-booking',
                element: <Pages.InvestigationBooking />
              },
              {
                path: 'sample-collection',
                element: <Pages.SampleCollection />
              },
              {
                path: 'sample-recieved',
                element: <Pages.SampleRecieved />
              },
              {
                path: 'sample-repeat',
                element: <Pages.SampleRepeat />
              },
              {
                path: 'lis-receipt-voucher',
                element: <Pages.LisReceiptVoucher />
              },
              {
                path: 'lab-test-date-change',
                element: <Pages.LabTestDateChange />
              },
              {
                path: 'result-dashboard',
                element: <Pages.ResultDashboard />
              },
              {
                path: 'result-entry/result-dashboard/:id',
                element: <Pages.ResultEntry />
              },
              {
                path: 'test-report/result-dashboard/:testId',
                element: <Pages.TestReport />
              },
              {
                path: 'allow-lab-test-cancellation',
                element: <Pages.AllowLabTestCancellation />
              },
              {
                path: 'lab-test-date-change',
                element: <Pages.LabTestDateChange />
              },
              {
                path: 'investigation-report-print',
                element: <Pages.InvestigationReportPrint />
              },
              {
                path: 'sample-received',
                element: <Pages.SampleRecieved />
              },
              {
                path: 'daily-investigation-report',
                element: <Pages.DailyInvestifationReport />
              },
              {
                path: 'sample-collection-report',
                element: <Pages.SampleCollectionReport />
              },
              {
                path: 'Uhid-IPD-No-Wise-report',
                element: <Pages.UhidIPDNoWiseReport />
              },
              {
                path: 'user-authority-master',
                element: <Pages.UserAuthorityMaster />
              }
            ]
          },
          {
            path: 'radiology',
            children: [
              {
                index: true,
                element: <Pages.Radiology />
              },
              {
                path: 'template-master',
                element: <Pages.RadiologyTemplatesMaster />
              },
              {
                path: 'room-master',
                element: <Pages.RadiologyRoomMaster />
              },
              {
                path: 'radiology-authority-doctor-master',
                element: <Pages.RadiologyAuthorityDoctorMaster />
              },
              {
                path: 'diagnosis-master',
                element: <Pages.RadiologyDiagnosisMaster />
              },
              {
                path: 'radiology-service-acknowledgement',
                element: <Pages.RadioServiceAcknowledgement />
              },
              {
                path: 'rad-service-ack-update-status',
                element: <Pages.RadServiceAckUpdateStatus />
              },
              {
                path: 'procedure-report',
                element: <Pages.ProcedureReport />
              },
              {
                path: 'radiology-status-report',
                element: <Pages.RadiologyStatusReport />
              },
              {
                path: 'radiology-service-booking',
                element: <Pages.ServiceBooking />
              },
              // {
              //   path: 'sub-group-user-mapping',
              //   element: <Pages.Sub />
              // },
              {
                path: 'radiology-service-booking-report',
                element: <Pages.RadiologyServiceBookingReport />
              }
            ]
          },

          {
            path: 'inpatient-management',
            children: [
              {
                index: true,
                element: <Pages.Radiology />
              },
              {
                path: 'service-master',
                element: <Pages.ServiceMaster />
              },
              {
                path: 'doctor-fees-setup',
                element: <Pages.DoctorFeeSetup />
              },
              {
                path: 'price-list-master',
                element: <Pages.PriceListMaster />
              },
              {
                path: 'room-master',
                element: <Pages.RoomMaster />
              },
              {
                path: 'ward-category-master',
                element: <Pages.WardCategoryMaster />
              },
              {
                path: 'ward-master',
                element: <Pages.WardMaster />
              },
              {
                path: 'floor-master',
                element: <Pages.FloorMaster />
              },
              {
                path: 'department-unit-master',
                element: <Pages.DepartmentUnitMaster />
              },
              {
                path: 'department-unit-head',
                element: <Pages.DepartmentUnitHead />
              },
              {
                path: 'nursing-station-master',
                element: <Pages.NursingStationMaster />
              },
              {
                path: 'indoor-registeration',
                element: <Pages.IndoorRegisteration />
              },
              {
                path: 'indoor-status',
                element: <Pages.IndoorStatus />
              },
              {
                path: 'indoor-service',
                element: <Pages.IndoorService />
              },
              {
                path: 'consultant-transfer',
                element: <Pages.ConsultantTransfer />
              },
              {
                path: 'indoor-billing-management',
                element: <Pages.IndoorBillingManagement />
              },
              {
                path: 'patient-discharge',
                element: <Pages.PatientDischarge />
              },
              {
                path: 'discharge-summary',
                element: <Pages.DischargeSummary />
              },
              {
                path: 'payment-refund-voucher',
                element: <Pages.PaymentRefundVoucher />
              },
              {
                path: 'gate-pass',
                element: <Pages.GatePass />
              },
              {
                path: 'receipt-voucher',
                element: <Pages.ReceiptVoucher />
              },
              {
                path: 'reception-enquiry',
                element: <Pages.ReceptionEnquiry />
              },
              {
                path: 'consultant-visiting',
                element: <Pages.ConsultantVisiting />
              },
              {
                path: 'ward-wise-consultant-visit-charges',
                element: <Pages.WardWiseConsultantVisitCharges />
              },
              {
                path: 'active-patient-reports',
                element: <Pages.IpdActivePatientReport />
              },
              {
                path: 'credit-register-report',
                element: <Pages.CreditRegisterReport />
              },
              {
                path: 'balance-register-report',
                element: <Pages.BalanceRegisterReport />
              },
              {
                path: 'bill-register-report',
                element: <Pages.BillRegisterReport />
              },
              {
                path: 'discount-register-report',
                element: <Pages.DiscountRegisterReport />
              },
              {
                path: 'collection-analysis-report',
                element: <Pages.CollectionAnalysisReport />
              },
              {
                path: 'refund-register',
                element: <Pages.RefundRegisterReport />
              },
              {
                path: 'service-register-report',
                element: <Pages.ServiceRegisterReport />
              },
              {
                path: 'consultant-revenue-analysis-report',
                element: <Pages.ConsultantRevenueAnalysisReport />
              },
              {
                path: 'indoor-collection-register',
                element: <Pages.IndoorCollectionRegisterReport />
              },
              {
                path: 'ipd-admission-register-reports',
                element: <Pages.IpdAdmissionRegisterReport />
              },
              {
                path: 'ipd-discharge-register',
                element: <Pages.IpdPatientDischargeRegisterReport />
              },
              {
                path: 'change-ipd-sponsor',
                element: <Pages.ChangeIpdSponsor />
              },
              {
                path: 'doctor-ledger',
                element: <Pages.DoctorLedgerReport />
              },
              {
                path: 'clean-room',
                element: <Pages.RoomCleaningStatus />
              },
              {
                path: 'discharge-summary-template-master',
                element: <Pages.DischargeSummaryTemplateMaster />
              },
              {
                path: 'visit-type-master',
                element: <Pages.VisitTypeMaster />
              },
              {
                path: 'sponsor-wise-ipd-report',
                element: <Pages.SponsorWiseIpdReport />
              },
              {
                path: 'collection-summary',
                element: <Pages.CollectionSummary />
              },
              {
                path: 'discharge-summary-templates',
                element: <Pages.DischargeSummaryTemplates />
              },
            ]
          },

          {
            path: 'nurse-module',
            children: [
              {
                index: true,
                element: <Pages.NURSE />
              },
              {
                path: 'discharge-mode-master',
                element: <Pages.DischargeModeMaster />
              },
              {
                path: 'room-chart',
                element: <Pages.RoomChart />
              },
              {
                path: 'nursing-handover-item-master',
                element: <Pages.NursingHandoverItemMaster />
              },
              {
                path: 'room-allotment',
                element: <Pages.RoomAllotment />
              },
              {
                path: 'room-transfer',
                element: <Pages.RoomTransfer />
              },
              {
                path: 'room-transfer-accept',
                element: <Pages.RoomTransferAccept />
              },
              {
                path: 'indent-requisition-form',
                element: <Pages.IndentRequisitionForm />
              },
              {
                path: 'patient-discharge-request',
                element: <Pages.PatientDischargeRequest />
              },
              {
                path: 'blood-request',
                element: <Pages.BloodRequestForm />
              },
              {
                path: 'relieve-discharged-patient',
                element: <Pages.RelieveDischargePatient />
              },
              {
                path: 'room-cleaning-status',
                element: <Pages.RoomCleaningStatus />
              },
              {
                path: 'nursing-handover-form',
                element: <Pages.NursingHandoverForm />
              },
              {
                path: 'room-status-report',
                element: <Pages.RoomStatusReport />
              }
            ]
          },
          {
            path: 'operation-theatre',
            children: [
              {
                index: true,
                element: <Pages.OT />
              }
            ]
          },
          {
            path: 'lis',
            children: [
              {
                index: true,
                element: <Pages.LIS />
              },
              {
                path: 'test-main-group-master',
                element: <Pages.TestMainGroupMaster />
              },
              {
                path: 'test-sub-group-master',
                element: <Pages.TestSubGroupMaster />
              },
              {
                path: 'category-master',
                element: <Pages.CategoryMaster />
              },
              {
                path: 'specimen-master',
                element: <Pages.SpecimenMaster />
              },
              {
                path: 'lis-discount-master',
                element: <Pages.DiscountsMaster />
              },
              {
                path: 'out-source-lab-master',
                element: <Pages.OutSourceLabMaster />
              },
              {
                path: 'lab-diagnosis-master',
                element: <Pages.LabDiagnosisMaster />
              },
              {
                path: 'lis-remark-master',
                element: <Pages.RemarksMaster />
              },
              {
                path: 'lis-reason-master',
                element: <Pages.ReasonsMaster />
              },
              {
                path: 'antimicrobials-master',
                element: <Pages.AntimicrobialsMaster />
              },
              {
                path: 'sensitivity-master',
                element: <Pages.SensitivityMaster />
              },
              {
                path: 'machine-master',
                element: <Pages.MachineMaster />
              },
              {
                path: 'lis-discount-authority-master',
                element: <Pages.DiscountAuhtorityMaster />
              },
              {
                path: 'lis-sponsor-master',
                element: <Pages.LisSponsorMaster />
              },
              {
                path: 'lis-templates-master',
                element: <Pages.LisTemplatesMaster />
              },
              {
                path: 'lis-referral-master',
                element: <Pages.LisReferralMaster />
              },
              {
                path: 'lis-rate-list-master',
                element: <Pages.LisRateListMaster />
              },
              {
                path: 'price-list-bed-category-wise',
                element: <Pages.PriceListBedCategoryWise />
              },
              {
                path: 'lis-test-price-list',
                element: <Pages.LisPriceListMaster />
              },
              {
                path: 'test-price-management',
                element: <Pages.TestPriceManagement />
              },
              {
                path: 'collection-center',
                element: <Pages.CollectionCenterMaster />
              },
              {
                path: 'lab-authority-doctor-master',
                element: <Pages.LabAuthorityDoctorMaster />
              },
              {
                path: 'machine-testitem-mapping',
                element: <Pages.MachineTestItemMapping />
              },
              {
                path: 'referral-share-setup',
                element: <Pages.ReferralShareSetup />
              },
              {
                path: 'doctor-share-setup',
                element: <Pages.DoctorShareSetup />
              },
              {
                path: 'test-master',
                element: <Pages.LisTestMaster />
              },
              {
                path: 'test-panel-master',
                element: <Pages.LisTestPanelMaster />
              },
              {
                path: 'investigation-booking',
                element: <Pages.InvestigationBooking />
              },
              {
                path: 'sample-collection',
                element: <Pages.SampleCollection />
              },
              {
                path: 'sample-recieved',
                element: <Pages.SampleRecieved />
              },
              {
                path: 'sample-repeat',
                element: <Pages.SampleRepeat />
              },
              {
                path: 'lis-receipt-voucher',
                element: <Pages.LisReceiptVoucher />
              },
              {
                path: 'lab-test-date-change',
                element: <Pages.LabTestDateChange />
              },
              {
                path: 'result-entry',
                element: <Pages.ResultEntry />
              },
              {
                path: 'daily-investigation-report',
                element: <Pages.DailyInvestifationReport />
              }
            ]
          },
          {
            path: 'ot',
            children: [
              {
                index: true,
                element: <Pages.OT />
              },
              {
                path: 'anaesthesia-master',
                element: <Pages.AnaesthesiaMaster />
              },
              {
                path: 'region-master',
                element: <Pages.RegionMaster />
              },
              {
                path: 'equipment-type-master',
                element: <Pages.EquipmenttypeMaster />
              },
              {
                path: 'equipment-master',
                element: <Pages.EquipmentMaster />
              },
              {
                path: 'operation-theatre-master',
                element: <Pages.OperationtheatreMaster />
              },
              {
                path: 'ot-notes',
                element: <Pages.OTNotesMaster />
              },
              {
                path: 'ot-schedule',
                element: <Pages.OTSchedule />
              },
              {
                path: 'ot-schedule-cancel',
                element: <Pages.OtScheduleCancel />
              },
              {
                path: 'patient-transfer',
                element: <Pages.PatientTransfer />
              },
              {
                path: 'ot-entry',
                element: <Pages.OTEntry />
              },
              {
                path: 'ot-schedule-register',
                element: <Pages.OtScheduleRegister />
              },
              {
                path: 'ot-entry-register',
                element: <Pages.OtEntryRegister />
              },
              {
                path: 'ot-schedule-status',
                element: <Pages.OtScheduleStatusList />
              },
              {
                path: 'patient-transfer',
                element: <Pages.PatientTransfer />
              }
            ]
          },
          {
            path: 'blood-bank',
            children: [
              {
                index: true,
                element: <Pages.BloodBank />
              },
              {
                path: 'component-master',
                element: <Pages.ComponentMaster />
              },
              {
                path: 'unit-master',
                element: <Pages.LisUnitMaster />
              },
              {
                path: 'bloodbank-master',
                element: <Pages.BloodBankMaster />
              },
              {
                path: 'bloodtype-master',
                element: <Pages.BloodTypeMaster />
              },
              {
                path: 'group-master',
                element: <Pages.BloodBankGroupMaster />
              },
              {
                path: 'donar-master',
                element: <Pages.DonarMaster />
              },
              {
                path: 'issue-blood',
                element: <Pages.BloodRequest />
              },
              // {
              //   path: 'blood-request-status',
              //   element: <Pages.BloodRequestStatus />
              // },
              {
                path: 'intake-blood',
                element: <Pages.IntakeBlood />
              },
              {
                path: 'blood-request-status-report',
                element: <Pages.BloodRequestStatusReport />
              },
              {
                path: 'donor-master-report',
                element: <Pages.DonorMasterReport />
              },
              {
                path: 'intake-blood-report',
                element: <Pages.IntakeBloodReport />
              }
            ]
          },
          {
            path: 'labour-room',
            children: [
              {
                index: true,
                element: <Pages.LABOURROOM />
              },
              {
                path: 'labour-room',
                element: <Pages.Labourroom />
              },
              {
                path: 'ivf-examination',
                element: <Pages.IVFForm />
              },
              {
                path: 'ivf-treatement',
                element: <Pages.IVFTreatement />
              }
            ]
          },
          {
            path: 'mis-report',
            children: [
              {
                index: true,
                element: <Pages.HMS />
              },
              {
                path: 'collection-summary',
                element: <Pages.CollectionSummary />
              },
              {
                path: 'consultant-revenue-analysis-report',
                element: <Pages.ConsultantRevenueAnalysisReport />
              },
              {
                path: 'service-register-report',
                element: <Pages.ServiceRegisterReport />
              },
              {
                path: 'refund-register',
                element: <Pages.RefundRegisterReport />
              },
              {
                path: 'credit-register-report',
                element: <Pages.CreditRegisterReport />
              },
              {
                path: 'balance-register-report',
                element: <Pages.BalanceRegisterReport />
              },
              {
                path: 'discount-register-report',
                element: <Pages.DiscountRegisterReport />
              },
              {
                path: 'collection-analysis-report',
                element: <Pages.CollectionAnalysisReport />
              },
              {
                path: 'doctor-ledger',
                element: <Pages.DoctorLedgerReport />
              },
              {
                path: 'indoor-collection-register',
                element: <Pages.IndoorCollectionRegisterReport />
              }
            ]
          },
          // {
          //   path: 'inventory',
          //   children: [
          //     {
          //       index: true,
          //       element: <Pages.INV />
          //     },
          //     {
          //       path: 'uqc-master',
          //       element: <Pages.UQCMaster />
          //     },
          //     {
          //       path: 'product-master',
          //       element: <Pages.ProductMaster />
          //     },
          //     {
          //       path: 'ware-house',
          //       element: <Pages.Warehouse />
          //     },
          //     {
          //       path: 'consigment-receipt',
          //       element: <Pages.ConsignmentReceipt />
          //     },
          //     {
          //       path: 'good-reciept-note',
          //       element: <Pages.GoodReceiptNote />
          //     },
          //     {
          //       path: 'consignment-return',
          //       element: <Pages.ConsignmentReturn />
          //     },
          //     {
          //       path: 'purchase-return',
          //       element: <Pages.PurchaseReturn />
          //     },
          //     {
          //       path: 'purchase-authorize',
          //       element: <Pages.GrnAuthorize />
          //     },
          //     {
          //       path: 'retail-sale-pos',
          //       element: <Pages.RetailSalePOS />
          //     },
          //     {
          //       path: 'sale-return',
          //       element: <Pages.SaleReturn />
          //     },
          //     {
          //       path: 'retail-sale-return',
          //       element: <Pages.RetailSaleReturn />
          //     },
          //     {
          //       path: 'product-details',
          //       element: <Pages.ProductDetails />
          //     },
          //     {
          //       path: 'indent-medicine-issue',
          //       element: <Pages.IndentMedicineIssue />
          //     },
          //     {
          //       path: 'indoor-medicine-return',
          //       element: <Pages.IndoorMedicineReturn />
          //     },
          //     {
          //       path: 'patient-receipt-voucher',
          //       element: <Pages.PatientReceiptVoucher />
          //     },
          //     {
          //       path: 'warehouse-stock-transfer-request',
          //       element: <Pages.WarehouseStockTransferRequest />
          //     },
          //     {
          //       path: 'batch-wise-expired-item',
          //       element: <Pages.BatchWiseExpiredItemReport />
          //     },
          //     {
          //       path: 'batch-wise-near-expiring-item',
          //       element: <Pages.NearByExpringItemReport />
          //     },
          //     {
          //       path: 'stock-status',
          //       element: <Pages.StockStatusReport />
          //     },
          //     {
          //       path: 'item-wise-sale-reort-register',
          //       element: <Pages.Itemwisesalereortregister />
          //     },
          //     {
          //       path: 'grn-report',
          //       element: <Pages.GrnReport />
          //     },
          //     {
          //       path: 'product-master-report',
          //       element: <Pages.ProductMasterReport />
          //     },
          //     {
          //       path: 'product-master-report-excel',
          //       element: <Pages.ProductMasterReportExcel />
          //     },
          //     {
          //       path: 'product-ledger',
          //       element: <Pages.ProductLedger />
          //     },
          //     {
          //       path: 'product-tracking-report',
          //       element: <Pages.ProductTrackingReport />
          //     },
          //     {
          //       path: 'purchase-requisition-report',
          //       element: <Pages.PurchaseRequisitionReport />
          //     },
          //     {
          //       path: 'purchase-order-report',
          //       element: <Pages.PurchaseOrderReport />
          //     },
          //     {
          //       path: 'purchase-summary',
          //       element: <Pages.PurchaseSummary />
          //     },
          //     {
          //       path: 'purchase-return-report',
          //       element: <Pages.PurchaseReturnReport />
          //     },
          //     {
          //       path: 'stock-transfer-request-report',
          //       element: <Pages.StockTransferRequestReport />
          //     },
          //     {
          //       path: 'stock-transfer-report',
          //       element: <Pages.StockTransferReport />
          //     },
          //     {
          //       path: 'stock-transfer-accept-report',
          //       element: <Pages.StockTransferAcceptReport />
          //     },
          //     {
          //       path: 'stock-transfer-form',
          //       element: <Pages.StockTransferForm />
          //     },
          //     {
          //       path: 'stock-adjutment-report',
          //       element: <Pages.StockAdjutmentReports />
          //     },
          //     {
          //       path: 'warehouse-report',
          //       element: <Pages.WarehouseReport />
          //     },
          //     {
          //       path: 'batch-wise-item-transaction',
          //       element: <Pages.BatchWiseItemTransaction />
          //     },
          //     {
          //       path: 'location-wise-stock-summary',
          //       element: <Pages.LocationWiseStockSummary />
          //     },
          //     {
          //       path: 'monthly-stock-movement-analysis',
          //       element: <Pages.MonthlyStockMovementAnalysis />
          //     },
          //     {
          //       path: 'update-batch-no',
          //       element: <Pages.UpdateBatchNo />
          //     },
          //     {
          //       path: 'purchase-order',
          //       element: <Pages.PurchaseOrder />
          //     },
          //     {
          //       path: 'purchase-order-term',
          //       element: <Pages.PurchaseOrderTerm />
          //     },
          //     {
          //       path: 'gst-report',
          //       element: <Pages.GstReport />
          //     },
          //     {
          //       path: 'stock-transfer-voucher',
          //       element: <Pages.StockTransferVoucher />
          //     },
          //     {
          //       path: 'stock-transfer-acceptance',
          //       element: <Pages.StockTransferAccept />
          //     },
          //     {
          //       path: 'user-wise-warehouse-mapping',
          //       element: <Pages.UserWiseWareHouseMapping />
          //     },
          //     {
          //       path: 'warehouse-stock-transfer-request-authorise',
          //       element: <Pages.WarehouseStockTransferRequestAuthorise />
          //     },
          //     {
          //       path: 'department-wise-consumption',
          //       element: <Pages.DepartmentWiseConsumption />
          //     },
          //     {
          //       path: 'patient-wise-consumption',
          //       element: <Pages.PatientWiseConsumption />
          //     },
          //     {
          //       path: 'cancel-ipd-indent',
          //       element: <Pages.CancelIPDIndent />
          //     },
          //     {
          //       path: 'stock-adjustment',
          //       element: <Pages.PharmacyStockAdjustment />
          //     },
          //     {
          //       path: 'collection-summary',
          //       element: <Pages.InvCollectionSummaryReport />
          //     },
          //     {
          //       path: 'purchase-requisition',
          //       element: <Pages.RequirementForm />
          //     },
          //     {
          //       path: 'zero-stock-report',
          //       element: <Pages.ZeroStockProductReportPdf />
          //     },
          //     {
          //       path: 'credit-report',
          //       element: <Pages.CreditReport />
          //     },
          //     {
          //       path: 'update-batch-rate',
          //       element: <Pages.UpdateBatchRate />
          //     },
          //     {
          //       path: 'product-info',
          //       element: <Pages.ProductInfo />
          //     }
          //   ]
          // },

          {
            path: 'pharmacy',
            children: [
              // Dashboard (index route)
              // {
              //   index: true,
              //   element: <Navigate to="dashboard" />,
              // },
              {
                index: true,
                element: <Pages.Dashboard />,
              },

              // ================= MASTER =================
              {
                path: 'medicines',
                element: <Pages.Medicines />,
              },
              {
                path: 'medicines/new',
                element: <Pages.CreateMedicine />,
              },
              {
                path: 'medicines/:id',
                element: <Pages.MedicineDetails />,
              },
              {
                path: 'medicines/:id/edit',
                element: <Pages.EditMedicine />,
              },
              {
                path: 'inventory',
                element: <Pages.Inventory />,
              },
              {
                path: 'racks',
                element: <Pages.Racks />,
              },
              {
                path: 'racks/new',
                element: <Pages.RackForm />,
              },
              {
                path: 'racks/:id',
                element: <Pages.RackDetails />,
              },
              {
                path: 'racks/:id/edit',
                element: <Pages.RackForm />,
              },
              {
                path: 'suppliers',
                children: [
                  {
                    index: true,
                    element: <Pages.Suppliers />,
                  },
                  {
                    path: 'new',
                    element: <Pages.CreateSupplier />,
                  },
                  {
                    path: ':id',
                    element: <Pages.SupplierDetails />,
                  },
                  {
                    path: ':id/edit',
                    element: <Pages.EditSupplier />,
                  },
                  {
                    path: ':id/products',
                    element: <Pages.SupplierProducts />,
                  },
                  {
                    path: ':id/communications',
                    element: <Pages.SupplierCommunications />,
                  },
                  {
                    path: ':id/analytics',
                    element: <Pages.SupplierAnalytics />,
                  },
                  {
                    path: ':id/documents',
                    element: <Pages.SupplierDocuments />,
                  },
                  {
                    path: ':id/payments',
                    element: <Pages.SupplierPayments />,
                  },
                  {
                    path: ':id/financials',
                    element: <Pages.SupplierFinancials />,
                  },
                  {
                    path: ':id/returns',
                    element: <Pages.SupplierReturns />,
                  }
                ],
              },

              // ================= PURCHASE TRANSACTION =================
              {
                path: 'purchases',
                children: [
                  {
                    index: true,
                    element: <Pages.Purchase />,
                  },
                  {
                    path: 'new',
                    element: <Pages.NewPurchase />,
                  },
                  {
                    path: ':id',
                    element: <Pages.PurchaseDetails />,
                  },
                  {
                    path: ':id/edit',
                    element: <Pages.EditPurchase />,
                  },
                  {
                    path: ':id/receive',
                    element: <Pages.ReceivePurchase />,
                  },
                ],
              },

              // ================= SALE TRANSACTION =================
              {
                path: 'sales',
                children: [
                  {
                    index: true,
                    element: <Pages.Sales />,
                  },
                  {
                    path: 'new',
                    element: <Pages.NewSale />,
                  },
                  {
                    path: ':id',
                    element: <Pages.SaleDetails />,
                  },
                  {
                    path: ':id/edit',
                    element: <Pages.EditSale />,
                  },
                ],
              },
              {
                path: 'returns',
                children: [
                  {
                    index: true,
                    element: <Pages.Returns />,
                  },
                  {
                    path: 'new',
                    element: <Pages.NewReturn />,
                  },
                  {
                    path: ':id',
                    element: <Pages.ReturnDetails />,
                  },
                ],
              },

              // ================= REPORTS =================
              {
                path: 'reports',
                element: <Pages.Reports />,
              },
            ],
          },
          {
            path: 'hospital-inventory',
            children: [
              // Dashboard (index route)
              // {
              //   index: true,
              //   element: <Navigate to="dashboard" />,
              // },
              {
                index: true,
                element: <Pages.InvDashboard />,
              },

              // ================= MASTER =================
              {
                path: 'items',
                element: <Pages.InvItemsPage />,
              },
              {
                path: 'items/new',
                element: <Pages.InvNewItems />,
              },
              {
                path: 'items/:id',
                element: <Pages.InvItemDetailsPage />,
              },
              {
                path: 'items/:id/edit',
                element: <Pages.InvEditItem />,
              },
              {
                path: 'inventory',
                element: <Pages.InvInventory />,
              },
              {
                path: 'racks',
                element: <Pages.InvRacks />,
              },
              {
                path: 'racks/new',
                element: <Pages.InvRackForm />,
              },
              {
                path: 'racks/:id',
                element: <Pages.InvRackDetails />,
              },
              {
                path: 'racks/:id/edit',
                element: <Pages.InvRackForm />,
              },
              {
                path: 'department-stock',
                element: <Pages.InvDepartmentStockPage />
              },
              {
                path: 'suppliers',
                children: [
                  {
                    index: true,
                    element: <Pages.InvSuppliers />,
                  },
                  {
                    path: 'new',
                    element: <Pages.InvCreateSupplier />,
                  },
                  {
                    path: ':id',
                    element: <Pages.InvSupplierDetails />,
                  },
                  {
                    path: ':id/edit',
                    element: <Pages.InvEditSupplier />,
                  },
                  {
                    path: ':id/products',
                    element: <Pages.InvSupplierProducts />,
                  },
                  {
                    path: ':id/communications',
                    element: <Pages.InvSupplierCommunications />,
                  },
                  {
                    path: ':id/analytics',
                    element: <Pages.InvSupplierAnalytics />,
                  },
                  {
                    path: ':id/documents',
                    element: <Pages.InvSupplierDocuments />,
                  },
                  {
                    path: ':id/payments',
                    element: <Pages.InvSupplierPayments />,
                  },
                  {
                    path: ':id/financials',
                    element: <Pages.InvSupplierFinancials />,
                  },
                  {
                    path: ':id/returns',
                    element: <Pages.InvSupplierReturns />,
                  }
                ],
              },

              // ================= PURCHASE TRANSACTION =================
              {
                path: 'purchases',
                children: [
                  {
                    index: true,
                    element: <Pages.InvPurchase />,
                  },
                  {
                    path: 'new',
                    element: <Pages.InvNewPurchase />,
                  },
                  {
                    path: ':id',
                    element: <Pages.InvPurchaseDetails />,
                  },
                  {
                    path: ':id/edit',
                    element: <Pages.InvEditPurchase />,
                  },
                  {
                    path: ':id/receive',
                    element: <Pages.InvReceivePurchase />,
                  },
                  {
                    path: ':id/grn',
                    element: <Pages.InvGRNView />
                  }
                ],
              },

              // ================= SALE TRANSACTION =================
              {
                path: 'item-issues',
                children: [
                  {
                    index: true,
                    element: <Pages.InvItemIssuesPage />,
                  },
                  {
                    path: 'new',
                    element: <Pages.InvCreateItemIssuePage />,
                  },
                  {
                    path: ':id',
                    element: <Pages.InvItemIssueDetailsPage />,
                  },
                  {
                    path: ':id/edit',
                    element: <Pages.EditSale />,
                  },
                ],
              },
              {
                path: 'item-issue-returns',
                children: [
                  {
                    index: true,
                    element: <Pages.InvItemIssueReturnsPage />,
                  },
                  {
                    path: 'new',
                    element: <Pages.InvCreateReturnPage />,
                  },
                  {
                    path: ':id',
                    element: <Pages.InvReturnDetailsPage />,
                  },
                ],
              },

              // ================= REPORTS =================
              {
                path: 'reports',
                element: <Pages.InvReports />,
              },
            ],
          },
          {
            path: 'software-management',
            children: [
              {
                index: true,
                element: <Pages.Admin />
              },
              {
                path: 'printoption',
                element: <Pages.PrintOption />
              },
              {
                path: 'role',
                element: <Pages.Role />
              },
              {
                path: 'role-permissions',
                element: <Pages.Permission />
              },
              {
                path: 'user-management',
                element: <Pages.UserManagement />
              },
              {
                path: 'Service-import-data',
                element: <Pages.ImportData />
              },
              {
                path: 'doctor-import-data',
                element: <Pages.DoctorImportData />
              },
              {
                path: 'sponser-import-data',
                element: <Pages.SponcerImportData />
              },
              {
                path: 'patient-import-data',
                element: <Pages.PatientImportData />
              },
              {
                path: 'product-master-import-data',
                element: <Pages.ProductMasterImportData />
              },
              {
                path: 'Pharmacy-Stock-import-data',
                element: <Pages.StockImportData />
              },
              {
                path: 'test-item-master-import-data',
                element: <Pages.TestItemMasterImportData />
              },
              {
                path: 'test-master-import-data',
                element: <Pages.TestMasterImportData />
              },
              {
                path: 'opd-billing-import-data',
                element: <Pages.OpdBillingImportData />
              },
              {
                path: 'ipd-billing-import-data',
                element: <Pages.IpdBillingImportData />
              },
              {
                path: 'voucher-series-setup',
                element: <Pages.VoucherSeriesSetup />
              },
              {
                path: 'price-list-master-import-data',
                element: <Pages.PriceListMasterImportData />
              },
              {
                path: 'lab-price-list-master-import-data',
                element: <Pages.LabPriceListMasterImportData />
              },
              {
                path: 'general-product-master-import',
                element: <Pages.GeneralProductMasterImport />
              },
              {
                path: 'general-product-stock-master-import',
                element: <Pages.GeneralProductStockMasterImport />
              },
              {
                path: 'sponsor-alocator',
                element: <Pages.SponsorAlocator />
              },
              {
                path: 'state-city-master-import',
                element: <Pages.StateCityImportData />
              },
              {
                path: 'stock-management', 
                element: <Pages.StockManagement />
              }
            ]
          },
          {
            path: 'eye-clinic',
            children: [
              {
                index: true,
                element: <Pages.OT />
              }
            ]
          },
          {
            path: 'biomedical-engg',
            children: [
              {
                index: true,
                element: <Pages.BioMedicalEngineering />
              }
            ]
          },
          {
            path: 'store-management',
            children: [
              {
                index: true,
                element: <Pages.StoreManagement />
              },
              {
                path: 'uqc-master',
                element: <Pages.StoreUqcMaster />
              },
              {
                path: 'product-master',
                element: <Pages.ProductMasters />
              },
              {
                path: 'ware-house',
                element: <Pages.Warehouse />
              },
              {
                path: 'consigment-receipt',
                element: <Pages.StoreConsignmentReceipt />
              },
              {
                path: 'good-reciept-note',
                element: <Pages.GoodReceiptNotes />
              },
              {
                path: 'consignment-return',
                element: <Pages.StoreConsignmentReturn />
              },
              {
                path: 'purchase-return',
                element: <Pages.StorePurchaseReturn />
              },
              {
                path: 'purchase-authorize',
                element: <Pages.StorePurchaseAuthorize />
              },
              {
                path: 'retail-sale-pos',
                element: <Pages.RetailSalePOS />
              },
              {
                path: 'sale-return',
                element: <Pages.SaleReturn />
              },
              {
                path: 'retail-sale-return',
                element: <Pages.RetailSaleReturn />
              },
              {
                path: 'product-details',
                element: <Pages.StoreProductDetails />
              },
              {
                path: 'purchase-order',
                element: <Pages.StorePurchaseOrder />
              },
              {
                path: 'department-wise-consumption',
                element: <Pages.DepartmentWiseConsumption />
              },
              {
                path: 'stock-adjustment',
                element: <Pages.StockAdjustment />
              },
              {
                path: 'add-product-Detail',
                element: <Pages.AddProductDetail />
              }
            ]
          },
          {
            path: 'emr',
            children: [
              {
                index: true,
                element: <Pages.OT />
              },
              {
                path: 'opd-requisition',
                element: <Pages.OpdRequisition />
              }
            ]
          },
          {
            path: 'tally',
            children: [
              {
                index: true,
                element: <Pages.GeneralLedger />
              },
              {
                path: 'account-ledger',
                element: <Pages.AccountLedger />
              },
              {
                path: 'account-group-type',
                element: <Pages.AccountGroup />
              },
              {
                path: 'account-group',
                element: <Pages.AccountGroups />
              },
              {
                path: 'cost-center-type-master',
                element: <Pages.CostCenterTypeMaster />
              },
              {
                path: 'cost-center-master',
                element: <Pages.CostCenterMaster />
              },
              {
                path: 'analysis-master',
                element: <Pages.AnalysisMaster />
              },
              {
                path: 'sub-analysis-master',
                element: <Pages.SubAnalysisMaster />
              },
              {
                path: 'supplier-payment-voucher',
                element: <Pages.SupplierPaymentVoucher />
              },
              {
                path: 'customer-receipt-voucher',
                element: <Pages.CustomerReceiptVoucher />
              },
              {
                path: 'patient-receipt-voucher',
                element: <Pages.PatientReceiptVoucher />
              },
              {
                path: 'retail-cash-voucher',
                element: <Pages.RetailCashVoucher />
              },
              {
                path: 'debit-cedit-note',
                element: <Pages.DebitCreditNote />
              },
              {
                path: 'journal-voucher',
                element: <Pages.JournalVoucher />
              },
              {
                path: 'payment-voucher',
                element: <Pages.RegularPaymentVoucher />
              },
              {
                path: 'receipt-voucher',
                element: <Pages.RegularReceiptVoucher />
              },
              {
                path: 'contra-voucher',
                element: <Pages.ContraVoucher />
              },
              {
                path: 'bank-reconciliation',
                element: <Pages.BankReconcilliation />
              },
              {
                path: 'bulk-authorization',
                element: <Pages.BulkAuthorization />
              },
              {
                path: 'adjustment-voucher',
                element: <Pages.AdjustmentVoucher />
              },
              {
                path: 'purchase-invoice',
                element: <Pages.TallyPurchaseInvoice />
              },
              {
                path: 'gst-report',
                element: <Pages.GstReport />
              },
              {
                path: 'expense-head-master',
                element: <Pages.ExpenseHeadMaster />
              },
              {
                path: 'doctor-share-setup-master',
                element: <Pages.DoctorShareSetupMaster />
              },
              {
                path: 'expense-entry',
                element: <Pages.ExpenseEntry />
              },
              {
                path: 'suppllier-payment-voucher',
                element: <Pages.SuppllierPaymentVoucher />
              },
              {
                path: 'bill-wise-ledger-opening-balance',
                element: <Pages.BillWiseLedgerOpeningBalance />
              },
              {
                path: 'doctor-share-audit',
                element: <Pages.DoctorShareAudit />
              },
              {
                path: 'patient-refund-voucher',
                element: <Pages.PatientRefundVoucher />
              }
            ]
          },
          // {
          //   path: 'mrd',
          //   children: [
          //     {
          //       index: true,
          //       element: <Pages.MRD />
          //     },
          //     {
          //       path: 'diagnosis-group-master',
          //       element: <Pages.DiagnosisGroupMaster />
          //     },
          //     {
          //       path: 'diagnosis-master',
          //       element: <Pages.DiagnosisMaster />
          //     },
          //     {
          //       path: 'icp-diagnosis-master',
          //       element: <Pages.IcpDiagnosisMaster />
          //     },
          //     {
          //       path: 'diagnosis-sub-group-master',
          //       element: <Pages.DiagnosisSubGroupMaster />
          //     },
          //     {
          //       path: 'deficiency-checklist-master',
          //       element: <Pages.DeficiencyChecklistMaster />
          //     },
          //     {
          //       path: 'icp-group-master',
          //       element: <Pages.IcpgroupMaster />
          //     },
          //     {
          //       path: 'icp-subgroup-master',
          //       element: <Pages.IcpSubGroupMaster />
          //     },
          //     {
          //       path: 'bin-master',
          //       element: <Pages.BinMaster />
          //     },
          //     {
          //       path: 'zone-master',
          //       element: <Pages.ZoneMaster />
          //     },
          //     {
          //       path: 'junior-resident-master',
          //       element: <Pages.JuniorResidentMaster />
          //     },
          //     {
          //       path: 'mlc-type-master',
          //       element: <Pages.MlcTypeMaster />
          //     },
          //     {
          //       path: 'deficiency-checklist',
          //       element: <Pages.DeficiencyChecklist />
          //     },
          //     {
          //       path: 'mrd-receipt-voucher',
          //       element: <Pages.MRDFileRecieptVoucher />
          //     },
          //     {
          //       path: 'mrd-receipt-voucher-update-status',
          //       element: <Pages.MRDFileRecieptVoucherUpdateStatus />
          //     },
          //     {
          //       path: 'file-requisition',
          //       element: <Pages.MRDFileRequisition />
          //     },
          //     {
          //       path: 'file-issue',
          //       element: <Pages.MRDFileIssue />
          //     },
          //     {
          //       path: 'file-return',
          //       element: <Pages.MRDFileReturn />
          //     },
          //     {
          //       path: 'ipd-patient-diagnosis',
          //       element: <Pages.IPDPatientDiagnosis />
          //     },
          //     {
          //       path: 'opd-artificial-manual-override',
          //       element: <Pages.OpdArtificialManualOverride />
          //     },
          //     {
          //       path: 'ipd-artificial-manual-override',
          //       element: <Pages.IpdArtificialManualOverride />
          //     },
          //     {
          //       path: 'bed-occupy-percentage-status',
          //       element: <Pages.BedOccupyPercentageStatus />
          //     }
          //   ]
          // },


          {
            path: 'mrd',
            children: [
              {
                index: true,
                element: <Pages.MRD />
              },
              {
                path: 'dashboard',
                element: <Pages.DashboardPage />
              },
              {
                path: 'mrd-files',
                children: [
                  {
                    path: '',
                    element: <Pages.MRDFilesPage />
                  },
                  {
                    path: ':id',
                    element: <Pages.MRDFilesPage />
                  }
                ]
              },
              {
                path: 'coding',
                children: [
                  {
                    path: '',
                    element: <Pages.MedicalCodingPage />
                  },
                  {
                    path: ':fileId',
                    element: <Pages.MedicalCodingPage />
                  },
                  {
                    path: ':fileId/versions',
                    element: <Pages.CodingVersionHistoryPage />
                  },
                  {
                    path: ':codingId/audit',
                    element: <Pages.CodingAuditTrailPage />
                  },
                  {
                    path: ':codingId/verify',
                    element: <Pages.CodingVerificationPage />
                  },
                  {
                    path: ':fileId/details',
                    element: <Pages.CodingDetailsPage />
                  },
                  {
                    path: ':fileId/edit',
                    element: <Pages.MedicalCodingPage />
                  },
                  
                ]
              },
              {
                path: 'reports',
                children: [
                  {
                    path: '',
                    element: <Pages.ReportsPage />
                  },
                  {
                    path: 'overdue-deficiencies',
                    element: <Pages.OverdueDeficienciesPage />
                  },
                  {
                    path: 'deficiency-statistics',
                    element: <Pages.DeficiencyStatisticsPage />
                  }
                ]
              },
              // Other routes
              {
                path: 'deficiency/:fileId',
                element: <Pages.DeficiencyPage />
              },
              {
                path: 'documents/:fileId',
                element: <Pages.DocumentsPage />
              },
              {
                path: 'movement',
                element: <Pages.FileMovementPage />
              },
              {
                path: 'master',
                element: <Pages.MasterDataPage />
              },
              {
                path: 'closure',
                element: <Pages.ClosurePage />
              },
              {
                path:'closure/:fileId',
                element: <Pages.ClosurePage/>
              },
              {
                path: 'archive',
                element: <Pages.ArchivePage />
              },
              {
                path: 'requests',
                element: <Pages.RequestsPage />
              },
              {
                path: 'settings',
                element: <Pages.SettingsPage />
              }
            ]
          },


          {
            path: 'tpa',
            children: [
              {
                index: true,
                element: <Pages.TPA />
              },
              {
                path: 'tpa-receipt-voucher',
                element: <Pages.TPAReceiptVoucher />
              },
              {
                path: 'echs-referral',
                element: <Pages.EchsReferral />
              },
              {
                path: 'tpa-claim-amount',
                element: <Pages.TpaClaimAmount />
              },
              {
                path: 'tpa-billing',
                element: <Pages.TpaBilling />
              },
              {
                path: 'tpa-claim-amount-status-report',
                element: <Pages.TpaClaimAmountReportStatus />
              }
            ]
          },
          {
            path: 'doctor-management',
            children: [
              {
                index: true,
                element: <Pages.DoctorWorkBench />
              },
              {
                path: 'opd-requisition',
                element: <Pages.OpdRequisition />
              },
              {
                path: 'ipd-requisition',
                element: <Pages.IpdRequisition />
              },
              {
                path: 'discharge-summary',
                element: <Pages.DischargeSummary />
              },
              {
                path: 'frequency-master',
                element: <Pages.FrequencyMaster />
              },
              {
                path: 'dose-master',
                element: <Pages.DoseMaster />
              },
              {
                path: 'patient-discharge-request',
                element: <Pages.PatientDischargeRequest />
              },
              {
                path: 'doctor-ledger-report',
                element: <Pages.DoctorLedgerReport />
              },
              {
                path: 'view-result',
                element: <Pages.ViewResult />
              },
              {
                path: 'view-doctor-visits-and-bills',
                element: <Pages.ViewDoctorVisitsAndBills />
              }
            ]
          },
          {
            path: 'physiotherapy',
            children: [
              {
                index: true,
                element: <Pages.Physiotheaphy />
              },
              {
                path: 'physiotherapy',
                element: <Pages.PhysiotherapyForm />
              }
            ]
          },
          {
            path: 'cssd',
            children: [
              {
                index: true,
                element: <Pages.CSSD />
              },
              {
                path: 'tray-assemble',
                element: <Pages.TrayAssemble />
              },
              {
                path: 'tray-request',
                element: <Pages.TrayRequest />
              },
              {
                path: 'tray-sterilized',
                element: <Pages.TraySterilized />
              }
            ]
          },
          {
            path: 'discharge-summary',
            children: [
              {
                index: true,
                element: <Pages.AR />
              },
              {
                path: 'discharge-summary',
                element: <Pages.DischargeSummary />
              }
            ]
          },
          {
            path: 'general-ledger',
            children: [
              {
                index: true,
                element: <Pages.GeneralLedger />
              },
              {
                path: 'account-ledger',
                element: <Pages.AccountLedger />
              },
              {
                path: 'account-group',
                element: <Pages.AccountGroup />
              }
            ]
          },
          {
            path: 'housekeeping-and-linen-management',
            // element: <Pages.HouseKeeping />,
            children: [
              // HOUSEKEEPING ROOT
              {
                path: 'housekeeping',
                children: [
                  {
                    index: true,
                    element: <Pages.HouseKeeping />
                  },
                  {
                    path: 'dashboard',
                    element: <Pages.HKDashboard />
                  },
                  {
                    path: 'checklist',
                    element: <Pages.ChecklistMaster />
                  },
                  {
                    path: 'staff',
                    element: <Pages.StaffMaster />
                  },
                  {
                    path: 'task-create',
                    element: <Pages.TaskCreate />
                  },
                  {
                    path: 'task-list',
                    element: <Pages.TaskList />
                  },
                  {
                    path: 'audit-create',
                    element: <Pages.AuditCreate />
                  },
                  {
                    path: 'audit-list',
                    element: <Pages.AuditList />
                  },
                  {
                    path: 'task-detail/:id',
                    element: <Pages.TaskDetail />
                  },
                  {
                    path: 'task-edit/:id',
                    element: <Pages.TaskEdit />
                  }
                ]
              },

              // LINEN ROOT
              {
                path: 'linen',
                children: [
                  {
                    index: true,
                    element: <Pages.LinenDashboard />
                  },
                  {
                    path: 'dashboard',
                    element: <Pages.LinenDashboard />
                  },
                  {
                    path: 'linen-item',
                    element: <Pages.LinenItemMaster />
                  },
                  {
                    path: 'linen-vendor',
                    element: <Pages.LinenVendorMaster />
                  },
                  {
                    path: 'linen-issue',
                    element: <Pages.LinenIssue />
                  },
                  {
                    path: 'linen-issue-list',
                    element: <Pages.LinenIssueList />
                  },
                  {
                    path: 'linen-dispatch',
                    element: <Pages.LinenDispatch />
                  },
                  {
                    path: 'linen-dispatch-list',
                    element: <Pages.LinenDispatchList />
                  },
                  {
                    path: 'linen-receive',
                    element: <Pages.LinenReceive />
                  },
                  {
                    path: 'linen-receive-list',
                    element: <Pages.LinenReceiveList />
                  },
                  {
                    path: 'linen-daily-report',
                    element: <Pages.LinenDailyReport />
                  },
                  {
                    path: 'ward-consumption',
                    element: <Pages.LinenWardConsumption />
                  },
                  {
                    path: 'linen-history',
                    element: <Pages.LinenHistory />
                  }
                ]
              }
            ]
          },
          {
            path: 'diet-management',
            children: [
              {
                index: true,
                element: <Pages.DietManagement />
              },
              {
                path: 'diet-management',
                element: <Pages.DietManagementForm />
              },
              {
                path: 'diet-report',
                element: <Pages.DietReport />
              }
            ]
          },
          {
            path: 'hr-management',
            children: [
              {
                index: true,
                element: <Pages.HRM />
              },
              {
                path: 'payroleitem',
                element: <Pages.PayRoleItem />
              },
              {
                path: 'employee-management',
                element: <Pages.EmployeeManagement />
              },
              {
                path: 'employee-attendance',
                element: <Pages.EmployeeAttendance />
              },
              {
                path: 'generate-salary-slip',
                element: <Pages.GenerateSalarySlip />
              }
            ]
          },
          {
            path: 'abdm',
            children: [
              {
                index: true,
                element: <Pages.Abdm />
              },
              {
                path: 'abdm-form',
                element: <Pages.AbdmForm />
              }
            ]
          }
        ]
      }
      // {
      //   path: 'pharmacy',
      //   children: [
      //     {
      //       index: true,
      //       element: <Pages.Pharmacy />
      //     },
      //     {
      //       path: 'inventory',
      //       children: [
      //         {
      //           index: true,
      //           element: <Pages.Inv />
      //         },
      //         {
      //           path: 'uqc-master',
      //           element: <Pages.UQCMaster />
      //         },
      //         {
      //           path: 'product-master',
      //           element: <Pages.ProductMaster />
      //         },
      //         {
      //           path: 'ware-house',
      //           element: <Pages.Warehouse />
      //         },
      //         {
      //           path: 'consigment-receipt',
      //           element: <Pages.ConsignmentReceipt />
      //         },
      //         {
      //           path: 'consignment-return',
      //           element: <Pages.ConsignmentReturn />
      //         },
      //         {
      //           path: 'good-reciept-note',
      //           element: <Pages.GoodReceiptNote />
      //         },
      //         {
      //           path: 'purchase-return',
      //           element: <Pages.PurchaseReturn />
      //         },
      //         {
      //           path: 'purchase-authorize',
      //           element: <Pages.GrnAuthorize />
      //         },
      //         {
      //           path: 'sale-return',
      //           element: <Pages.SaleReturn />
      //         },
      //         {
      //           path: 'retail-sale-pos',
      //           element: <Pages.RetailSalePOS />
      //         },
      //         {
      //           path: 'retail-sale-return',
      //           element: <Pages.RetailSaleReturn />
      //         },
      //         {
      //           path: 'warehouse-transfer-request',
      //           element: <Pages.WarehouseStockTransferRequest />
      //         },
      //         {
      //           path: 'purchase-order-term',
      //           element: <Pages.WarehouseStockTransferRequest />
      //         }
      //       ]
      //     },
      //     {
      //       path: 'general-ledger',
      //       children: [
      //         {
      //           index: true,
      //           element: <Pages.Ledger />
      //         }
      //       ]
      //     },
      //     {
      //       path: 'admin',
      //       children: [
      //         {
      //           index: true,
      //           element: <Pages.PharmacyAdmin />
      //         }
      //       ]
      //     }
      //   ]
      // },
      // {
      //   path: 'Lab',
      //   children: [
      //     {
      //       index: true,
      //       element: <Pages.Lab />
      //     },
      //     {
      //       path: 'lis',
      //       children: [
      //         {
      //           index: true,
      //           element: <Pages.Lab />
      //         },
      //         {
      //           path: 'test-main-group-master',
      //           element: <Pages.TestMainGroupMaster />
      //         },
      //         {
      //           path: 'test-sub-group-master',
      //           element: <Pages.TestSubGroupMaster />
      //         },
      //         {
      //           path: 'category-master',
      //           element: <Pages.CategoryMaster />
      //         },
      //         {
      //           path: 'specimen-master',
      //           element: <Pages.SpecimenMaster />
      //         },
      //         {
      //           path: 'test-master',
      //           element: <Pages.LisTestMaster />
      //         },
      //         {
      //           path: 'test-panel-master',
      //           element: <Pages.LisTestPanelMaster />
      //         },
      //         {
      //           path: 'lis-discount-master',
      //           element: <Pages.DiscountMaster />
      //         },
      //         {
      //           path: 'lis-discount-authority-master',
      //           element: <Pages.DiscountAuhtorityMaster />
      //         },
      //         {
      //           path: 'lis-sponsor-master',
      //           element: <Pages.LisSponsorMaster />
      //         },
      //         {
      //           path: 'lis-templates-master',
      //           element: <Pages.LisTemplatesMaster />
      //         },
      //         {
      //           path: 'lis-referral-master',
      //           element: <Pages.LisReferralMaster />
      //         },
      //         {
      //           path: 'lab-authority-doctor-master',
      //           element: <Pages.LabAuthorityDoctorMaster />
      //         },
      //         {
      //           path: 'investigation-booking',
      //           element: <Pages.InvestigationBooking />
      //         },
      //         {
      //           path: 'sample-collection',
      //           element: <Pages.SampleCollection />
      //         },
      //         {
      //           path: 'result-entry',
      //           element: <Pages.ResultEntry />
      //         }
      //       ]
      //     },
      //     {
      //       path: 'admin',
      //       children: [
      //         {
      //           index: true,
      //           element: <Pages.Admin />
      //         }
      //       ]
      //     }
      //   ]
      // }
    ]
  },
  {
    path: 'print/*',
    element: <Pages.Print />
  },
  {
    path: 'public/print/*',
    element: <Pages.Print isPublic />
  },
  {
    path: 'activation/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Pages.Activation />
      }
    ]
  },
  {
    path: 'licence-registration/',
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Pages.LicenceRegistration />
      }
    ]
  }
]);

export default router;
